module.exports = __webpack_public_path__ + "img/image3.93337b63.png";